/* 三國逗陣打 · 連線客戶端（M3，M4 加上大廳首頁、房間、聊天）
 * 只有從連線伺服器（server/server.js）開啟頁面時才會出現「連線對戰」。
 * 客戶端不跑遊戲邏輯：把操作送給伺服器，收到依隊伍過濾過的快照後，
 * 組成一個和單機 World 介面相同的「鏡像世界」交給畫面層與 HUD 使用。 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from '../core/sg.ts';
import { Clock, Track } from './interp.ts';
import { decodeVx } from './vx.ts';

const M = SG.MAP;
const $ = (id) => document.getElementById(id);
const SPEC = {};
SG.HEROES.forEach((h) => { SPEC[h.id] = h; });
[SG.SOLDIERS, SG.ARCHERS, SG.NEUTRAL].forEach((g) => Object.values(g).forEach((s) => { SPEC[s.id] = s; }));
SPEC[SG.LUBU.id] = SG.LUBU;
const HERO = Object.fromEntries(SG.HEROES.map((h) => [h.id, h]));
// 穿造型的武將：同一組（武將, 造型）共用一份 spec
const SKINNED = {};
const specOf = (sp, sk) => (sk && SPEC[sp] && SG.Meta ? (SKINNED[sp + ':' + sk] || (SKINNED[sp + ':' + sk] = SG.Meta.skinned(SPEC[sp], sk))) : SPEC[sp]);

let ws = null, lobby = null, world = null, panel = null, modes = null, listTimer = null;
let lastRoom = null, leaving = false, retry = null; // 斷線重連用
const send = (o) => { if (ws && ws.readyState === 1) ws.send(JSON.stringify(o)); };
const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
// 會員的名字可以點：打開玩家資料卡（home.ts 監聽 data-pid）；訪客沒有 5 碼 ID，照舊是純文字
const plink = (name, card) => (card ? `<button type="button" class="plink" data-pid="${esc(card)}">${esc(name)}</button>` : esc(name));
const cardOf = (pid) => { const p = lobby && lobby.players.find((o) => o.pid === pid); return p ? p.card : null; };
const NET = {
  inLobby: () => !!(ws && ws.readyState === 1 && lobby && lobby.state === 'lobby'),
  inRoom: () => !!(ws && ws.readyState === 1 && lobby),
  ping(o) { send({ t: 'mping', k: o.k, x: o.x, y: o.y, uid: o.uid }); }, // 隊伍訊號：伺服器只轉給隊友
};
SG.NET = NET;
NET.connect = (o) => connect(o); // 社交連線（social.ts）用來讓隊員跟上隊長
// 這台裝置的代碼：斷線重連、積分都靠它認人（清掉瀏覽器資料就是新的身分）
const dev = (() => { try { let d = localStorage.getItem('sankuo-dev'); if (!d) { d = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem('sankuo-dev', d); } return d; } catch (e) { return null; } })();
let saved = {};
try { saved = JSON.parse(localStorage.getItem('sankuo-online') || '{}'); } catch (e) { /* 忽略 */ }

// 有連線伺服器才顯示（發佈的單機頁面沒有 api/rooms，會安靜略過）
fetch('api/rooms', { cache: 'no-store' }).then((r) => (r.ok ? r.json() : null)).then((j) => { if (j && j.ok) { modes = j.modes; buildPanel(); renderRooms(j.rooms); } }).catch(() => {});

// ---------- 連線大廳首頁：名字、模式、快速配對、開房、輸入代碼、公開房間列表 ----------
function buildPanel() {
  panel = document.createElement('div');
  panel.className = 'online';
  const normal = Object.entries(modes).filter(([, m]) => !m.ranked);
  const q0 = saved.queue === 'normal' ? 'normal' : 'ranked';
  const opts = normal.map(([k, m]) => `<option value="${k}"${k === saved.mode ? ' selected' : ''}>${m.name}</option>`).join('');
  const chips = normal.map(([k, m]) => `<button type="button" class="bchip" data-m="${k}" aria-pressed="${k === (saved.mode && modes[saved.mode] && !modes[saved.mode].ranked ? saved.mode : 'std')}">${m.name.replace(/ · .*/, '')}</button>`).join('');
  panel.innerHTML = `<div id="on-hub">
      <h3 class="sect-h">出征<small>選擇對戰類型</small></h3>
      <div class="queues" id="on-queue" role="group" aria-label="對戰類型">
        <button type="button" class="queue q-ranked" data-q="ranked" aria-pressed="${q0 === 'ranked'}"><canvas class="mt-art" data-art="ranked" aria-hidden="true"></canvas><span class="mt-badge">計積分</span>
          <span class="mt-plaque"><i class="qseal" aria-hidden="true">排</i><span><b>排位</b><small>赤壁之戰 5v5 · 分陣營 · 禁選</small></span></span></button>
        <button type="button" class="queue q-normal" data-q="normal" aria-pressed="${q0 === 'normal'}"><canvas class="mt-art" data-art="normal" aria-hidden="true"></canvas><span class="mt-badge">自訂規則</span>
          <span class="mt-plaque"><i class="qseal" aria-hidden="true">戰</i><span><b>一般</b><small>房主決定戰役、選將與陣營</small></span></span></button>
      </div>
      <div class="bchips" id="on-mode-w"${q0 === 'ranked' ? ' hidden' : ''}><span class="on-note">戰役</span>${chips}<select id="on-mode" hidden aria-hidden="true">${opts}</select></div>
      <div class="match-row"><button class="btn primary match" type="button" id="on-quick"><span>開始配對</span><small id="on-quick-sub"></small></button>
        <div class="match-alt"><button class="btn" type="button" id="on-create">開新房間</button><label class="on-note"><input type="checkbox" id="on-priv"> 私人房</label>
          <span class="joinbox"><input id="on-room" maxlength="16" placeholder="房間代碼" value="${esc(saved.room || '')}" aria-label="房間代碼"><button class="btn" type="button" id="on-join">加入</button></span></div></div>
      <h4 class="rooms-h">公開房間</h4>
      <div id="on-rooms"></div>
    </div>
    <div id="on-lobby" hidden></div>
    <div id="on-qv" class="qv" hidden></div>
    <p class="on-note" id="on-note"></p>`;
  $('online-slot').replaceChildren(panel);
  let queue = q0;
  const sub = () => { $('on-quick-sub').textContent = queue === 'ranked' ? '排位 · 赤壁之戰 5v5' : '一般 · ' + modes[$('on-mode').value].name; };
  if (!modes[$('on-mode').value] || modes[$('on-mode').value].ranked) $('on-mode').value = 'std';
  $('on-queue').onclick = (e) => {
    const b = e.target.closest('[data-q]'); if (!b) return;
    queue = b.dataset.q;
    $('on-queue').querySelectorAll('[data-q]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    $('on-mode-w').hidden = queue === 'ranked'; sub();
  };
  // 戰役小按鈕和隱藏的 select 同步（測試與舊流程用 select）
  $('on-mode-w').onclick = (e) => { const c = e.target.closest('[data-m]'); if (!c) return; $('on-mode').value = c.dataset.m; $('on-mode-w').querySelectorAll('[data-m]').forEach((x) => x.setAttribute('aria-pressed', String(x === c))); sub(); };
  $('on-mode').onchange = () => { $('on-mode-w').querySelectorAll('[data-m]').forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.m === $('on-mode').value))); sub(); };
  sub();
  panel.querySelectorAll('canvas[data-art]').forEach((cv) => modeArt(cv, cv.dataset.art));
  const pick = () => (queue === 'ranked' ? { queue: 'ranked', mode: 'ranked' } : { queue: 'normal', mode: $('on-mode').value });
  // 排位：進配對佇列；一般：找有空位的房間
  $('on-quick').onclick = () => {
    if (SG.Game.fullscreen) SG.Game.fullscreen();
    // 組隊中：只有隊長能開始；排位全隊一起排，一般開一間私人房讓隊員跟進
    const S = SG.Social, party = S && S.party();
    if (party) {
      if (!S.isLeader()) return note('等隊長開始配對', true);
      if (queue === 'ranked') return S.send({ t: 's:queue' });
      return connect(Object.assign({ priv: true }, pick()));
    }
    connect(Object.assign(queue === 'ranked' ? { mm: true } : { quick: true }, pick()));
  };
  NET.partyHint = () => { const S = SG.Social, p = S && S.party(); const b = $('on-quick'); if (!b) return; b.disabled = !!p && !S.isLeader(); sub(); if (p) $('on-quick-sub').textContent += S.isLeader() ? ` · 隊伍 ${p.members.length} 人` : ' · 等隊長開始'; };
  $('on-create').onclick = () => { if (SG.Game.fullscreen) SG.Game.fullscreen(); connect(Object.assign({ priv: $('on-priv').checked }, pick())); };
  $('on-join').onclick = () => { const r = $('on-room').value.trim(); if (r) connect(Object.assign({ room: r }, pick())); else note('先輸入房間代碼', true); };
  $('on-rooms').onclick = (e) => { const b = e.target.closest('[data-room]'); if (b) connect({ room: b.dataset.room }); };
  // 重新整理頁面：一分鐘內還在對戰（或禁選）中，就自動連回去接手自己的武將
  try {
    const ss = JSON.parse(localStorage.getItem('sankuo-session') || 'null');
    if (ss && ss.live && Date.now() - ss.t < 60000) { note('偵測到進行中的對戰，正在連回去…'); connect({ room: ss.room }); }
  } catch (e) { /* 忽略 */ }
  listTimer = setInterval(() => { if (!ws) fetch('api/rooms', { cache: 'no-store' }).then((r) => r.json()).then((j) => renderRooms(j.rooms)).catch(() => {}); }, 3000);
}
// 戰役卡的人物畫：排位是聯軍對魏軍的對峙，一般是三國各一名武將並肩
function modeArt(cv, kind) {
  const W = 480, H = 150, dpr = Math.min(2, window.devicePixelRatio || 1);
  cv.width = W * dpr; cv.height = H * dpr;
  const ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  let g;
  if (kind === 'ranked') {
    g = ctx.createLinearGradient(0, 0, W, 0); g.addColorStop(0, '#2c4a2c'); g.addColorStop(0.47, '#3a1a18'); g.addColorStop(0.53, '#1a2140'); g.addColorStop(1, '#22305c');
  } else { g = ctx.createLinearGradient(0, 0, 0, H); g.addColorStop(0, '#3a2c22'); g.addColorStop(1, '#14121a'); }
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  // 雲紋與火光
  const r = ctx.createRadialGradient(W / 2, H * 0.9, 0, W / 2, H * 0.9, W * 0.55); r.addColorStop(0, kind === 'ranked' ? 'rgba(255,140,60,.45)' : 'rgba(255,210,140,.25)'); r.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.fillStyle = r; ctx.fillRect(0, 0, W, H);
  ctx.save(); ctx.globalAlpha = 0.09; ctx.fillStyle = '#f5e6c8'; ctx.font = '900 150px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.fillText(kind === 'ranked' ? '戰' : '義', W / 2, H - 6); ctx.restore();
  const by = (id) => HERO[id];
  const put = (id, x, s, flip) => { const h = by(id); if (!h || !SG.drawHero) return; ctx.save(); ctx.translate(x, H + 8); ctx.scale(flip ? -s : s, s); SG.drawHero(ctx, h, SG.poseOf(h, 'idle', 0.3), 0); ctx.restore(); };
  if (kind === 'ranked') { put('zhaoyun', 52, 1.1, false); put('guanyu', 128, 1.32, false); put('zhangliao', 430, 1.1, true); put('caocao', 352, 1.32, true); }
  else { put('sunshangxiang', 116, 1.12, false); put('simayi', 364, 1.12, true); put('zhugeliang', 240, 1.3, false); }
  g = ctx.createLinearGradient(0, H * 0.55, 0, H); g.addColorStop(0, 'rgba(23,20,26,0)'); g.addColorStop(1, 'rgba(23,20,26,.85)');
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
}
function renderRooms(list) {
  const box = $('on-rooms');
  if (!box) return;
  if (!list || !list.length) { box.innerHTML = '<p class="on-note rooms-empty">目前沒有公開房間，按「開始配對」就會幫你開一間。</p>'; return; }
  const st = { lobby: '等待中', draft: '選將中', playing: '對戰中' };
  const PK = { draft: '禁選', blind: '盲選', random: '隨機' };
  box.innerHTML = `<table class="on-list"><thead><tr><th>房間</th><th>模式</th><th>人數</th><th>狀態</th><th></th></tr></thead><tbody>${list.map((r) =>
    `<tr><td>${esc(r.code)}</td><td>${r.queue === 'ranked' ? '<b class="rk-tag">排位</b> ' : ''}${esc(r.name)}${r.queue === 'ranked' ? '' : `<small class="on-note"> · ${PK[r.pick] || ''}${r.split ? ' · 分陣營' : ''}</small>`}</td><td>${r.players}/${r.seats}${r.spectators ? `（觀戰 ${r.spectators}）` : ''}</td><td>${st[r.state] || r.state}</td>
      <td><button class="btn" type="button" data-room="${esc(r.code)}">${r.state === 'lobby' && r.players < r.seats ? '加入' : '觀戰'}</button></td></tr>`).join('')}</tbody></table>`;
}
function note(t, bad) { const n = $('on-note'); if (n) { n.textContent = t; n.style.color = bad ? '#ff9a8a' : ''; } }

// 會員：連線時伺服器靠 session cookie 認人，名字用帳號暱稱（SG.Account 在 src/game/account.ts）
function connect(o) {
  if (ws) return;
  const AC = SG.Account;
  if (AC && AC.ready && !o._acc) { AC.ready.then(() => connect(Object.assign({ _acc: 1 }, o))); return; }
  const account = AC && AC.user;
  // 排位要登入：先開登入視窗，登入成功再接著配對
  // 用代碼加入既有房間時不在這裡擋，交給伺服器依房間規則判斷
  if (o.queue === 'ranked' && !o.room && !account && AC && AC.available) { AC.open('login', '排位需要先登入會員').then((u) => { if (u) connect(o); }); return; }
  // 名字：會員用帳號暱稱；訪客用主公暱稱（設定一次），還沒設定就先問
  const name = account ? account.nick : (SG.Meta && SG.Meta.profile.nick) || '';
  if (!name && SG.Home && SG.Home.askNick) { SG.Home.askNick().then((n) => { if (n) connect(o); }); return; }
  leaving = false;
  saved = { name, room: o.room || saved.room || '', mode: o.mode && o.mode !== 'ranked' ? o.mode : saved.mode, queue: o.queue || saved.queue };
  try { localStorage.setItem('sankuo-online', JSON.stringify(saved)); } catch (e) { /* 忽略 */ }
  const url = (location.protocol === 'https:' ? 'wss://' : 'ws://') + location.host + '/ws';
  ws = new WebSocket(url);
  const hello = Object.assign({ t: 'hello', name, dev }, o); delete hello._acc;
  ws.onopen = () => { send(hello); startLink(); };
  ws.onmessage = (e) => { link.last = performance.now(); let m; try { m = JSON.parse(e.data); } catch (x) { return; } onMessage(m); };
  ws.onclose = () => {
    ws = null;
    // 對戰或禁選中意外斷線：畫面留著，每 2 秒自動重連一次（60 秒內伺服器會把武將還給同一台裝置）
    if (!leaving && lastRoom && (world || (lobby && lobby.state !== 'lobby'))) { reconnect(name); return; }
    lobby = null; renderLobby(); closeDraft();
    note('已離開房間（或與伺服器的連線中斷）。', true);
    if (world) { world.over = world.over === null ? -1 : world.over; world = null; }
  };
}
// ---------- 連線品質：每 2 秒量一次往返延遲；太久沒收到伺服器的資料就提示，再久就主動重連 ----------
const link = { rtt: 0, last: 0, timer: null, warned: false };
NET.link = link;
function startLink() {
  clearInterval(link.timer); link.last = performance.now(); link.warned = false;
  link.timer = setInterval(() => {
    if (!ws || ws.readyState !== 1) { clearInterval(link.timer); return; }
    send({ t: 'ping', c: performance.now() });
    const quiet = performance.now() - link.last;
    if (world && quiet > 3000) {
      showPing(null);
      if (!link.warned) { link.warned = true; world.say('連線不穩，等待伺服器回應…', 'warn'); }
      if (quiet > 12000) { link.warned = false; try { ws.close(); } catch (e) { /* 已關閉 */ } } // 交給 onclose 的自動重連
    } else link.warned = false;
  }, 2000);
}
function showPing(ms) {
  const el = $('ping'); if (!el) return;
  el.hidden = !world;
  if (ms === null) { el.textContent = '連線不穩'; el.className = 'st bad'; return; }
  el.textContent = `PING ${Math.round(ms)}ms`;
  el.className = 'st ' + (ms < 80 ? 'good' : ms < 160 ? 'mid' : 'bad');
}
// 手機切到背景再回來：連線可能已經被系統切斷。斷了就馬上重連；看起來還在就送一個 ping，2.5 秒沒回應就主動斷開重連
let hiddenAt = 0;
document.addEventListener('visibilitychange', () => {
  if (document.hidden) { hiddenAt = Date.now(); return; }
  const away = hiddenAt ? (Date.now() - hiddenAt) / 1000 : 0; hiddenAt = 0;
  if (!lastRoom || !(world || (lobby && lobby.state !== 'lobby'))) return;
  if (world && away >= 90) world.say(`你離開了 ${Math.round(away)} 秒，這段時間由電腦代打；現在交還給你`, 'warn');
  else if (world && away >= 5) world.say('回到戰場', 'info');
  if (!ws || ws.readyState > 1) { if (retry) { clearInterval(retry); retry = null; } if (!ws) connect({ room: lastRoom, name: saved.name }); return; }
  const t0 = performance.now(); send({ t: 'ping', c: t0 });
  setTimeout(() => { if (ws && link.last < t0) { try { ws.close(); } catch (e) { /* 已關閉 */ } } }, 2500); // 交給 onclose 的自動重連
});
function reconnect(name) {
  if (retry) return;
  let n = 0;
  if (world) world.say('與伺服器的連線中斷了，重新連線中…', 'warn');
  note('連線中斷，重新連線中…', true);
  retry = setInterval(() => {
    if (ws) return;
    if (++n > 30) { clearInterval(retry); retry = null; lobby = null; renderLobby(); closeDraft(); note('重新連線失敗。', true); if (world) { world.over = world.over === null ? -1 : world.over; world = null; } return; }
    connect({ room: lastRoom, name });
  }, 2000);
}

// ---------- 房間畫面：兩隊座位、準備、房主設定、聊天 ----------
let mlSent = null; // 已經送過謀略選擇的房間
let skinSent = null, skinDraft = null; // 已經送過造型的房間（進房一次、禁選開始再一次：中間可能換了造型）
function renderLobby() {
  const box = $('on-lobby'), hub = $('on-hub');
  if (!box) return;
  if (!lobby) { box.hidden = true; hub.hidden = false; return; }
  box.hidden = false; hub.hidden = true;
  const L = lobby, M2 = L.modes[L.mode], meP = L.players.find((p) => p.pid === L.you) || {}, host = L.you === L.host;
  const teamNames = ['聯軍', '魏軍'], open = M2.coop ? [0] : [0, 1];
  const seat = (p) => `<li class="${p.pid === L.you ? 'me' : ''}">${p.pid === L.host ? '<b class="host">房主</b>' : ''}${plink(p.name, p.card)}${M2.ranked && p.rating ? `<small class="rt">${p.rating}</small>` : ''}${p.ready ? '<em class="rdy">準備</em>' : ''}</li>`;
  const col = (t) => {
    const ps = L.players.filter((p) => p.team === t);
    const empty = Array.from({ length: Math.max(0, M2.size - ps.length) }, () => `<li class="empty">${L.bots || (M2.coop && t === 1) ? '電腦' : '空位'}</li>`).join('');
    return `<div><h4 style="color:${t ? 'var(--foe)' : 'var(--ally)'}">${teamNames[t]} ${ps.length}/${M2.size}</h4><ul>${ps.map(seat).join('')}${empty}</ul>
      ${L.state === 'lobby' && meP.team !== t ? `<button class="btn" type="button" data-team="${t}">換到${teamNames[t]}</button>` : ''}</div>`;
  };
  const specs = L.players.filter((p) => p.team === null);
  // 一般房：房主可改戰役、選將方式、陣營；排位房規則固定
  const edit = host && L.state === 'lobby' && L.queue !== 'ranked';
  const modeSel = edit ? `<select id="on-setmode">${Object.entries(L.modes).filter(([, m]) => !m.ranked).map(([k, m]) => `<option value="${k}"${k === L.mode ? ' selected' : ''}>${m.name}</option>`).join('')}</select>` : `<b>${esc(M2.name)}</b>`;
  const pickSel = edit && M2.picks.length > 1 ? `<select id="on-setpick">${M2.picks.map((k) => `<option value="${k}"${k === L.pick ? ' selected' : ''}>${L.picks[k]}</option>`).join('')}</select>` : `<b>${esc(L.picks[L.pick])}</b>`;
  const splitSel = edit ? `<select id="on-setsplit"><option value="1"${L.split ? ' selected' : ''}>分陣營（聯軍蜀吳、魏軍魏）</option><option value="0"${L.split ? '' : ' selected'}>不分陣營</option></select>` : `<b>${L.split ? '分陣營' : '不分陣營'}</b>`;
  box.innerHTML = `<div class="on-row"><span>房間 <b>${esc(L.code)}</b></span>${L.queue === 'ranked' ? '<b class="rk-tag">排位</b>' : '<span class="on-note">一般</span>'}<span>戰役 ${modeSel}</span><span class="on-note">${esc(M2.note || '')}</span></div>
    <div class="on-row"><span>選將 ${pickSel}</span><span>陣營 ${splitSel}</span>
      ${M2.coop ? (host && L.state === 'lobby' ? `<span>電腦難度 <select id="on-setdiff">${Object.entries(L.diffs).map(([k, n]) => `<option value="${k}"${k === L.diff ? ' selected' : ''}>${n}</option>`).join('')}</select></span>` : `<span>電腦難度 <b>${esc(L.diffs[L.diff])}</b></span>`) : ''}
      ${host && L.state === 'lobby' ? `<label><input type="checkbox" id="on-setpriv"${L.priv ? ' checked' : ''}> 私人房</label>` : L.priv ? '<span class="on-note">私人房</span>' : ''}
      ${L.queue === 'ranked' || M2.coop ? '' : edit ? `<label><input type="checkbox" id="on-setbots"${L.bots ? ' checked' : ''}> 空位補電腦</label>` : `<span class="on-note">${L.bots ? '空位補電腦' : '空位不補電腦'}</span>`}</div>
    ${L.state === 'lobby' && meP.team !== null && SG.mlPicker ? `<div class="on-row">${SG.mlPicker()}</div>` : ''}
    <div class="on-teams">${open.map(col).join('')}</div>
    <p class="on-note">觀戰：${specs.length ? specs.map((p) => esc(p.name)).join('、') : '無'}
      ${L.state === 'lobby' && meP.team !== null ? '　<button class="btn" type="button" data-team="spec">改成觀戰</button>' : ''}</p>
    <div class="on-row on-acts">
      ${L.state === 'lobby' && meP.team !== null ? `<button class="btn${meP.ready ? '' : ' primary'}" type="button" id="on-ready">${meP.ready ? '取消準備' : '準備'}</button>` : ''}
      ${host && L.state === 'lobby' ? '<button class="btn primary" type="button" id="on-start">開始對戰</button>' : ''}
      <button class="btn" type="button" id="on-leave">離開房間</button>
      ${L.state === 'lobby' ? `<span class="on-note">全員準備後由房主開始，接著進入${esc(L.picks[L.pick])}選將。</span>` : ''}</div>
    <div class="on-chat"><div class="on-log" id="on-log">${L.chat.map(chatLine).join('')}</div>
      <div class="on-row"><input id="on-say" maxlength="120" placeholder="說點什麼（Enter 送出）"><button class="btn" type="button" id="on-send">送出</button></div></div>`;
  box.querySelectorAll('[data-team]').forEach((b) => { b.onclick = () => send({ t: 'team', team: b.dataset.team === 'spec' ? null : +b.dataset.team }); });
  if ($('on-ready')) $('on-ready').onclick = () => send({ t: 'ready', on: !meP.ready });
  if ($('on-start')) $('on-start').onclick = () => send({ t: 'start' });
  if ($('on-setmode')) $('on-setmode').onchange = (e) => send({ t: 'mode', mode: e.target.value });
  if ($('on-setpriv')) $('on-setpriv').onchange = (e) => send({ t: 'priv', on: e.target.checked });
  if (SG.bindMlPicker) SG.bindMlPicker(box, renderLobby, (id) => send({ t: 'ml', id }));
  if ($('on-setbots')) $('on-setbots').onchange = (e) => send({ t: 'bots', on: e.target.checked });
  if ($('on-setdiff')) $('on-setdiff').onchange = (e) => send({ t: 'diff', diff: e.target.value });
  if ($('on-setpick')) $('on-setpick').onchange = (e) => send({ t: 'pickmode', pick: e.target.value });
  if ($('on-setsplit')) $('on-setsplit').onchange = (e) => send({ t: 'split', on: e.target.value === '1' });
  $('on-leave').onclick = () => { leaving = true; try { localStorage.removeItem('sankuo-session'); } catch (e) { /* 忽略 */ } if (ws) ws.close(); };
  const say = () => { const i = $('on-say'); if (i.value.trim()) send({ t: 'chat', text: i.value }); i.value = ''; };
  $('on-send').onclick = say;
  $('on-say').onkeydown = (e) => { if (e.key === 'Enter') { e.preventDefault(); say(); } };
  const log = $('on-log'); log.scrollTop = log.scrollHeight;
}
function chatLine(l) {
  if (l.sys) return `<p class="sys">${esc(l.text)}</p>`;
  const tag = l.team === null ? '［全體］' : l.team === 'spec' ? '［觀戰］' : '［隊伍］';
  return `<p>${lobby && lobby.state !== 'lobby' ? `<i>${tag}</i>` : ''}<b>${esc(l.from)}</b>：${esc(l.text)}</p>`;
}

// ---------- 對戰中的聊天：Enter 開輸入框，預設隊伍頻道；Shift+Enter 或開頭打 /all 送全體 ----------
let chatBox = null, chatIn = null;
function ensureChat() {
  if (chatBox) return;
  chatBox = document.createElement('div'); chatBox.className = 'gchat';
  chatBox.innerHTML = '<div class="gchat-log"></div><input class="gchat-in" maxlength="120" hidden placeholder="隊伍頻道（Shift+Enter 或 /all 送全體，Esc 取消）">';
  document.body.appendChild(chatBox);
  chatIn = chatBox.querySelector('input');
  chatIn.addEventListener('keydown', (e) => {
    e.stopPropagation();
    if (e.key === 'Escape') { chatIn.value = ''; chatIn.hidden = true; chatIn.blur(); }
    if (e.key !== 'Enter') return;
    let text = chatIn.value.trim(), all = e.shiftKey;
    if (/^\/all\s/i.test(text)) { all = true; text = text.replace(/^\/all\s+/i, ''); }
    if (text) send({ t: 'chat', text, all });
    chatIn.value = ''; chatIn.hidden = true; chatIn.blur();
  });
  window.addEventListener('keydown', (e) => {
    if (!world || e.key !== 'Enter' || document.activeElement === chatIn) return;
    e.preventDefault(); chatIn.hidden = false; chatIn.focus();
  });
}
// 觀戰者用數字鍵切換要跟的武將
window.addEventListener('keydown', (e) => {
  if (!world || !world.spectator || /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
  const d = /^Digit(\d)$/.exec(e.code);
  if (d) { world.follow = (+d[1] + 9) % 10; e.stopImmediatePropagation(); }
}, true);
function gameChat(l) {
  if (!chatBox) return;
  const p = document.createElement('p');
  const tag = l.sys ? '' : l.team === null ? '［全體］' : l.team === 'spec' ? '［觀戰］' : '［隊伍］';
  p.innerHTML = l.sys ? esc(l.text) : `<i>${tag}</i><b>${esc(l.from)}</b>：${esc(l.text)}`;
  if (l.team !== null && l.team !== 'spec' && !l.sys) p.className = 'team';
  const log = chatBox.querySelector('.gchat-log');
  log.appendChild(p); while (log.children.length > 8) log.firstChild.remove();
  setTimeout(() => p.classList.add('old'), 9000);
}

// ---------- 選將畫面：禁選（輪流禁、選）與盲選（同時選）----------
// 伺服器每秒推一次狀態：骨架只建一次，各區塊內容真的變了才換，武將清單只改狀態不重建
// （以前整頁 innerHTML 重建，每秒重畫幾十張頭像、清單捲軸還會被捲回最上面）
let draftEl = null, draftSel = null, draftRole = '全部', draftView = null, draftGridKey = '', draftFrac = -1;
const ROLE_TABS = ['全部', '坦克', '戰士', '刺客', '射手', '法師', '輔助', '指揮'];
const FAC = { shu: '蜀', wu: '吳', wei: '魏' };
const PHASE_LEN = { draft: 30, swap: 15, blind: 40 }; // 跟 server/draft.ts 的 TURN／SWAP／BLIND 一致
function paintPortraits(el) { el.querySelectorAll('canvas[data-pc]').forEach((c) => { const h = HERO[c.dataset.pc]; if (h && SG.Game) SG.Game.portrait(c, h, +(c.dataset.s || c.getAttribute('width')) || 44); }); }
function put(el, html) { if (el._html === html) return; el._html = html; el.innerHTML = html; paintPortraits(el); }
function renderDraft(v) {
  draftView = v;
  if (!draftEl) {
    SG.covered = true;
    draftEl = document.createElement('div'); draftEl.className = 'draft';
    draftEl.innerHTML = `<header class="dr-top"><div class="dr-side t0"></div><div class="dr-center"><div class="dr-phase"></div><div class="dr-clock"></div><div class="dr-bar"><i></i></div><div class="dr-pips"></div></div><div class="dr-side t1"></div></header>
      <div class="dr-body"><section class="dr-team t0"></section><div class="dr-mid"><div class="dr-tabs"></div><div class="dr-grid"></div><div class="dr-act"></div></div><section class="dr-team t1"></section></div>`;
    document.body.appendChild(draftEl);
    draftGridKey = ''; draftFrac = -1;
    draftEl.addEventListener('click', (e) => {
      const tile = e.target.closest('[data-h]'); if (tile && !tile.disabled) { draftSel = tile.dataset.h; renderDraft(draftView); return; }
      const tab = e.target.closest('[data-role]'); if (tab) { draftRole = tab.dataset.role; renderDraft(draftView); return; }
      if (e.target.closest('#dr-lock') && draftSel) { send({ t: 'draft', hero: draftSel }); draftSel = null; }
      if (e.target.closest('#dr-skip')) send({ t: 'draft', hero: null });
      const sw = e.target.closest('[data-swap]'); if (sw) send({ t: 'swap', with: +sw.dataset.swap });
    });
  }
  const q = (sel) => draftEl.querySelector(sel);
  const you = lobby ? lobby.you : null, t = v.turn, blind = v.kind === 'blind';
  const myTeam = v.seats.findIndex((team) => team.some((s) => s.pid === you));
  const mySeat = myTeam >= 0 ? v.seats[myTeam].find((s) => s.pid === you) : null;
  // 輪到我：禁選看輪次；盲選是自己還沒鎖定
  const mine = blind ? !!(mySeat && !mySeat.hero && v.phase === 'blind') : !!(t && v.seats[t.team][t.seat].pid === you);
  const banning = !blind && mine && t.kind === 'ban';
  // 可選名單：分陣營時，選角看自己陣營、禁用看對手陣營
  const poolTeam = banning ? 1 - t.team : myTeam >= 0 ? myTeam : t ? t.team : 0;
  const pool = v.pools && v.pools[poolTeam] ? new Set(v.pools[poolTeam]) : null;
  const banned = blind ? new Set() : new Set([...v.bans[0], ...v.bans[1]]);
  const picked = new Set(blind ? (myTeam >= 0 ? v.seats[myTeam].map((s) => s.hero).filter(Boolean) : []) : v.seats.flat().map((s) => s.hero).filter(Boolean));
  if (draftSel && (banned.has(draftSel) || picked.has(draftSel) || !mine)) draftSel = null;
  const name = (id) => (HERO[id] ? HERO[id].name : id);
  draftEl.classList.toggle('mine', mine); draftEl.classList.toggle('banning', banning);
  draftEl.dataset.turn = t ? String(t.team) : v.phase === 'swap' ? 'swap' : '';

  // 上方：兩隊名號、這一手、倒數、進度列
  const side = (T) => `<b>${T ? '魏軍' : '聯軍'}</b><small>${T ? '紅方' : '藍方'}${v.pools ? '　' + (T ? '魏' : '蜀・吳') : ''}${T === myTeam ? '　· 我方' : ''}</small>`;
  put(q('.dr-side.t0'), side(0)); put(q('.dr-side.t1'), side(1));
  const who = !t ? '' : v.seats[t.team][t.seat].pid === you ? '你' : esc(v.seats[t.team][t.seat].name);
  put(q('.dr-phase'), v.phase === 'swap' ? '<small>選將完成</small><b>換位階段</b><em>跟隊友互相按「交換」就會換武將</em>'
    : blind ? `<small>盲選</small><b>同時選將</b><em>${mine ? '選好武將按鎖定' : '看不到對手選誰'}</em>`
    : `<small>第 ${v.step + 1} / ${v.total} 手</small><b class="k-${t.kind} t${t.team}">${t.team ? '紅方' : '藍方'}${t.kind === 'ban' ? '禁用' : '選角'}</b><em>${mine ? `輪到你${t.kind === 'ban' ? '禁用' : '選角'}！` : `${who} 思考中…`}</em>`);
  put(q('.dr-clock'), `<b class="${v.left <= 5 ? 'hot' : ''}">${v.left}</b>`);
  const frac = Math.max(0, Math.min(1, v.left / (PHASE_LEN[v.phase] || 30))), bar = q('.dr-bar i');
  if (frac > draftFrac) { bar.style.transition = 'none'; bar.style.width = (frac * 100) + '%'; void bar.offsetWidth; bar.style.transition = ''; }
  else bar.style.width = (frac * 100) + '%';
  draftFrac = frac; bar.classList.toggle('hot', v.left <= 5);
  put(q('.dr-pips'), blind || !v.seq ? '' : v.seq.map((k, i) => `<i class="${k[0] === 'b' ? 'b' : 'p'} t${k[1]}${i < v.step || v.phase !== 'draft' ? ' done' : i === v.step ? ' now' : ''}"></i>`).join(''));

  // 兩側：禁用欄與座位
  const nowSeat = (T, i) => !blind && t && t.team === T && t.seat === i && t.kind === 'pick';
  const teamCol = (T) => {
    if (!v.seats[T].length) return `<p class="on-note dr-coop">合作模式：魏軍全由電腦操控，開戰時補上。</p>`;
    const nb = Math.max(1, v.nb ? v.nb[T] : 5);
    const bans = blind ? '' : `<div class="dr-bans" aria-label="禁用">${Array.from({ length: nb }, (_, i) => { const id = v.bans[T][i]; const now = t && t.kind === 'ban' && t.team === T && v.bans[T].length === i;
      return `<span class="ban${id ? ' on' : ''}${now ? ' now' : ''}" title="${id ? name(id) : ''}">${id ? `<canvas data-pc="${id}" data-s="40"></canvas>` : ''}</span>`; }).join('')}</div>`;
    const seats = v.seats[T].map((s, i) => {
      const hidden = blind && T !== myTeam && v.phase === 'blind', hero = hidden ? '' : s.hero || '';
      const label = hidden ? (s.hero ? '已選定' : '選將中…') : s.hero ? name(s.hero) : nowSeat(T, i) || (blind && v.phase === 'blind') ? '選角中…' : '尚未選將';
      const swap = v.phase === 'swap' && T === myTeam && s.pid !== null && s.pid !== you ? `<button class="btn" type="button" data-swap="${s.pid}">${v.swaps.some(([a, b]) => a === s.pid && b === you) ? '同意交換' : '請求交換'}</button>` : '';
      return `<div class="dr-seat${nowSeat(T, i) ? ' now' : ''}${s.pid === you ? ' me' : ''}${hero ? ' set' : ''}"><span class="pf">${hero ? `<canvas data-pc="${hero}" data-s="52"></canvas>` : ''}</span>
        <div class="tx"><b>${label}</b><small>${plink(s.name, s.pid === you ? null : cardOf(s.pid))}${s.pid === you ? '（你）' : ''}${hero && HERO[hero] ? ' · ' + HERO[hero].roleText : ''}</small></div>${swap}</div>`;
    }).join('');
    return `${bans}<div class="dr-seats">${seats}</div>`;
  };
  put(q('.dr-team.t0'), teamCol(0)); put(q('.dr-team.t1'), teamCol(1));

  // 中間：定位分頁、武將清單（名單變了才重建，平常只改狀態）、出手區
  put(q('.dr-tabs'), ROLE_TABS.map((r) => `<button class="btn" type="button" data-role="${r}" aria-pressed="${r === draftRole}">${r}</button>`).join('')
    + (v.pools ? `<span class="on-note">${banning ? '禁用對手陣營' : '可選'}：${poolTeam ? '魏' : '蜀、吳'}</span>` : ''));
  const grid = q('.dr-grid'), key = draftRole + '|' + (pool ? poolTeam : '-');
  if (key !== draftGridKey) {
    draftGridKey = key; grid.scrollTop = 0;
    const list = SG.HEROES.filter((h) => (draftRole === '全部' || h.role === draftRole) && (!pool || pool.has(h.id)));
    put(grid, list.map((h) => `<button type="button" class="dr-h f-${h.faction}" data-h="${h.id}"><span class="pf"><canvas data-pc="${h.id}" data-s="60"></canvas></span><b>${h.name}</b><small>${h.roleText}</small></button>`).join(''));
  }
  grid.querySelectorAll('.dr-h').forEach((b) => {
    const id = b.dataset.h, x = banned.has(id) ? 'ban' : picked.has(id) ? 'pick' : '';
    if ((b.dataset.x || '') !== x) { if (x) b.dataset.x = x; else delete b.dataset.x; }
    const off = !!x || !mine; if (b.disabled !== off) b.disabled = off;
    b.classList.toggle('sel', draftSel === id);
  });
  const H = draftSel && HERO[draftSel], verb = banning ? '禁用' : '鎖定';
  put(q('.dr-act'), mine ? `<div class="dr-pick">${H ? `<span class="pf"><canvas data-pc="${H.id}" data-s="64"></canvas></span><div><b>${H.name}</b><small>${H.sub || ''}　${FAC[H.faction] || ''} · ${H.roleText}</small><ul>${H.skills.map((k, i) => `<li><kbd>${'QWER'[i]}</kbd>${esc(k.name)}</li>`).join('')}</ul></div>` : `<p class="on-note">從清單點一名武將${banning ? '來禁用' : ''}</p>`}</div>
      <div class="dr-btns"><button class="btn primary dr-lock" type="button" id="dr-lock"${draftSel ? '' : ' disabled'}>${verb}${H ? '：' + H.name : ''}</button>${banning ? '<button class="btn" type="button" id="dr-skip">這一手不禁</button>' : ''}</div>`
    : `<p class="on-note dr-wait">${blind ? (mySeat && mySeat.hero ? `你選了 ${name(mySeat.hero)}，等其他人…` : '觀戰中…') : v.phase === 'swap' ? '換位中…' : '等待對方出手…'}</p>`);
}
function closeDraft() { SG.covered = false; if (draftEl) { draftEl.remove(); draftEl = null; draftSel = null; } }
// ---------- 大亂鬥發將畫面：自己的武將、重抽一次、隊友拿到誰、倒數 ----------
function renderDeal(v) {
  if (!draftEl) {
    SG.covered = true;
    draftEl = document.createElement('div'); draftEl.className = 'draft deal';
    document.body.appendChild(draftEl);
    draftEl.addEventListener('click', (e) => { if (e.target.closest('#dl-reroll')) send({ t: 'reroll' }); });
  }
  const mine = v.hand.find((h) => h.pid === v.you), myTeam = mine ? mine.team : null;
  const sk = (h) => (h.skills || []).map((s, i) => `<li><kbd>${'QWER'[i]}</kbd> ${esc(s.name)}${s.passive ? '（被動）' : ''}</li>`).join('');
  const H2 = mine && HERO[mine.hero];
  draftEl.innerHTML = `<div class="dr-head">大亂鬥：系統發給你的武將　<b class="${v.left <= 5 ? 'hot' : ''}">${v.left}</b> 秒後開戰</div>
    <div class="dl-body">${H2 ? `<div class="dl-me"><canvas data-pc="${H2.id}" width="120" height="120"></canvas><div><h2>${esc(H2.name)}</h2><p class="on-note">${esc(H2.role)}</p><ul>${sk(H2)}</ul>
      <button class="btn primary" type="button" id="dl-reroll"${mine.rerolled ? ' disabled' : ''}>${mine.rerolled ? '已經重抽過了' : '重抽一次'}</button></div></div>` : '<p class="on-note">觀戰中，等待開戰…</p>'}
      <div class="dl-team">${myTeam === null ? '' : `<h3>隊友</h3>${v.hand.filter((h) => h.team === myTeam && h.pid !== v.you).map((h) => `<div class="dr-seat"><canvas data-pc="${h.hero}" width="44" height="44"></canvas><div><b>${esc(HERO[h.hero] ? HERO[h.hero].name : h.hero)}</b><small>${h.rerolled ? '重抽過' : ''}</small></div></div>`).join('') || '<p class="on-note">其餘由電腦補上</p>'}`}</div></div>`;
  paintPortraits(draftEl);
}

// ---------- 排位配對：佇列畫面與「找到對手」的接受視窗 ----------
let qv = null, acceptEl = null, titleT = null;
function showQueue(m) {
  qv = { since: m.since, off: (m.now || Date.now()) - Date.now(), n: m.n, need: m.need || 10 };
  $('on-hub').hidden = true; $('on-lobby').hidden = true; $('on-qv').hidden = false;
  if (m.text) note(m.text);
  drawQueue();
  clearInterval(showQueue.t); showQueue.t = setInterval(drawQueue, 1000);
}
const mmss = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
function drawQueue() {
  const box = $('on-qv'); if (!box || !qv) return;
  const waited = Math.max(0, (Date.now() + qv.off - qv.since) / 1000);
  // 排位不補電腦、不倒數：只顯示已經等了多久與佇列人數
  box.innerHTML = `<div class="qv-ring"><i></i><span>${mmss(waited)}</span></div>
    <div><h4>排位配對中</h4><p class="on-note">赤壁之戰 5v5 · 已等候 ${mmss(waited)} · 佇列中 ${qv.n} 人<br>排位不補電腦，湊滿 ${qv.need} 名真人才會開戰。</p>
    <button class="btn" type="button" id="qv-cancel">取消配對</button></div>`;
  $('qv-cancel').onclick = () => { send({ t: 'unqueue' }); };
}
function hideQueue() { clearInterval(showQueue.t); qv = null; const b = $('on-qv'); if (b) b.hidden = true; }
function showAccept(m) {
  closeAccept();
  acceptEl = document.createElement('div'); acceptEl.className = 'mm-accept';
  const end = Date.now() + m.left * 1000;
  acceptEl.innerHTML = `<div class="mm-box"><p class="mm-eyebrow">排位 · 赤壁之戰</p><h2>找到對手！</h2><p class="on-note">${m.humans} 名玩家</p>
    <div class="mm-bar"><i></i></div><div class="mm-acts"><button class="btn" type="button" id="mm-no">拒絕</button><button class="btn primary" type="button" id="mm-yes">接受</button></div><p class="on-note" id="mm-st"></p></div>`;
  document.body.appendChild(acceptEl);
  const bar = acceptEl.querySelector('.mm-bar i'), tick = () => { if (!acceptEl) return; const f = Math.max(0, (end - Date.now()) / (m.left * 1000)); bar.style.width = (f * 100) + '%'; if (f > 0) requestAnimationFrame(tick); };
  tick();
  $('mm-yes').onclick = () => { send({ t: 'accept', id: m.id, on: true }); $('mm-yes').disabled = $('mm-no').disabled = true; $('mm-st').textContent = '已接受，等待其他人…'; };
  $('mm-no').onclick = () => { send({ t: 'accept', id: m.id, on: false }); closeAccept(); };
  $('mm-yes').focus();
  if (SG.Audio) { try { SG.Audio.init(); SG.Audio.play('levelup'); } catch (e) { /* 沒有音效就算了 */ } }
  // 分頁在背景：標題閃爍提醒
  const t0 = document.title; let on = false;
  clearInterval(titleT); titleT = setInterval(() => { document.title = (on = !on) ? '【找到對手】' + t0 : t0; }, 700);
  closeAccept.title = t0;
}
function closeAccept() { if (acceptEl) { acceptEl.remove(); acceptEl = null; } if (titleT) { clearInterval(titleT); titleT = null; if (closeAccept.title) document.title = closeAccept.title; } }

function onMessage(m) {
  if (m.t === 'queue') {
    if (m.state === 'searching') { closeAccept(); showQueue(m); return; }
    closeAccept(); hideQueue(); if (m.text) note(m.text, m.state === 'cancelled'); leaving = true; if (ws) ws.close(); return;
  }
  if (m.t === 'match') { showAccept(m); return; }
  if (m.t === 'mping') { if (world && SG.Game.showPing) SG.Game.showPing(m); return; }
  if (m.tp === 's') { if (world) apply(m); return; }
  if (m.t === 'draft') { if (skinDraft !== lastRoom) { skinDraft = lastRoom; send({ t: 'skins', v: SG.Meta.skinsChosen() }); } renderDraft(m); return; }
  if (m.t === 'deal') { renderDeal(m); return; }
  if (m.t === 'room') {
    closeAccept(); hideQueue();
    lobby = m; lastRoom = m.code;
    if (m.state === 'lobby' && mlSent !== m.code && SG.Meta.mlChosen()) { mlSent = m.code; send({ t: 'ml', id: SG.Meta.mlChosen() }); } // 進房就告訴伺服器要帶的謀略
    if (skinSent !== m.code) { skinSent = m.code; send({ t: 'skins', v: SG.Meta.skinsChosen() }); } // 造型（伺服器驗證會員有沒有）
    try { localStorage.setItem('sankuo-session', JSON.stringify({ room: m.code, t: Date.now(), live: m.state !== 'lobby' })); } catch (e) { /* 忽略 */ } if (retry) { clearInterval(retry); retry = null; note('已重新連上。'); } renderLobby(); return; }
  if (m.t === 'chat') {
    if (lobby) { lobby.chat.push(m.line); if (lobby.chat.length > 30) lobby.chat.shift(); const log = $('on-log'); if (log) { log.insertAdjacentHTML('beforeend', chatLine(m.line)); log.scrollTop = log.scrollHeight; } }
    if (world) gameChat(m.line);
    return;
  }
  if (m.t === 'pong') { const r = performance.now() - m.c; link.rtt = link.rtt ? link.rtt * 0.7 + r * 0.3 : r; NET.rtt = link.rtt; showPing(link.rtt); return; }
  if (m.t === 'err') { note(m.text, true); if (world) world.say(m.text, 'warn'); if (m.login && SG.Account) SG.Account.open('login', m.text); return; }
  if (m.t === 'start') { closeDraft(); ensureChat(); startGame(m); return; }
  if (m.t === 'end') {
    if (m.rating) { const r = m.rating; note(`排位積分 ${r.delta >= 0 ? '+' : ''}${r.delta}：${r.before} → ${r.after}`); if (world) world.say(`積分 ${r.delta >= 0 ? '+' : ''}${r.delta}（${r.after}）`, 'big'); }
    if (m.copper) { if (SG.Cloud) SG.Cloud.applyWallet(m.copper.wallet, m.copper.rev); if (world) world.say(`銅錢 +${m.copper.granted}`, 'good'); } // 連線對戰的銅錢由伺服器發
    if (world && m.stat) world.player.stat = Object.assign({}, world.player.stat, m.stat); // 個人戰績（含累計抵禦傷害）
    if (world && m.team) finalBoard(world, m.team);
    if (world) { world.over = m.winner; world = null; } document.body.classList.remove('spectating'); try { localStorage.removeItem('sankuo-session'); } catch (e) { /* 忽略 */ } return; }
}

// 結算的團隊戰況：用伺服器給的最終資料更新每位武將（等級、戰績、裝備、傷害），整場沒看到過的敵將補進來
function finalBoard(w, team) {
  const known = new Map(w.board.map((h) => [h.id, h]));
  for (const id of Object.keys(team)) {
    const f = team[id];
    let h = known.get(+id) || (+id === w.myId ? w.player : null);
    if (!h) { h = { id: +id, kind: 'hero', team: f.tm, spec: SPEC[f.sp] || null, name: f.nm, alive: true, respawn: 0, items: [] }; w.board.push(h); }
    if (h === w.player && !known.has(h.id)) w.board.push(h);
    if (f.pc) { h.card = f.pc; h.pname = f.pn; }
    Object.assign(h, { lv: f.lv, kills: f.kda[0], deaths: f.kda[1], assists: f.kda[2], items: f.it.map((i) => (i ? SG.ITEM[i] : null)) });
    h.stat = Object.assign({}, h.stat, { dmgHero: f.dmgHero, taken: f.taken, dmgBld: f.dmgBld });
  }
}

// ---------- 鏡像世界 ----------
function blankStatus() { return { stun: 0, root: 0, slow: 0, slowAmt: 0, fear: 0, silence: 0, invis: 0, shield: 0, atkUp: 0, atkUpAmt: 0, msUp: 0, msUpAmt: 0, regen: 0 }; }
function startGame(m) {
  const b = M.bases[m.team];
  const w = Object.create(SG.World.prototype);
  Object.assign(w, {
    t: 0, units: [], projs: [], zones: [], feed: [], msgs: [], dmgEvents: [], vfx: [], kills: [0, 0], over: null,
    wind: { on: 0, next: 120 }, seal: { state: 'wait', x: 0, y: 0, holder: null, t: 360 }, supply: [0, 0],
    camps: M.camps.map((c) => ({ c, units: [] })),
    rules: m.rules || { buyDead: false, solo: false, diff: null }, // 沒有 rules 時 canBuy 會丟例外，整個畫面迴圈停住（線上開商店就當機）
    byId: new Map(), board: [], clock: new Clock(), myId: m.spectate ? -1 : m.hero, myTeam: m.team, spectator: !!m.spectate, follow: 0,
  });
  document.body.classList.toggle('spectating', !!m.spectate);
  // 客戶端預測：自己的武將照操作立刻移動，伺服器回報後再校正（localStorage 的 sankuo-predict=0 可以關掉，比較用）
  let predOn = true; try { predOn = localStorage.getItem('sankuo-predict') !== '0'; } catch (e) { /* 忽略 */ }
  w.pred = { on: predOn && !m.spectate, seq: 0, hist: new Map(), x: 0, y: 0, ox: 0, oy: 0, spd: 0, path: null, goal: null, pathT: 0, synced: false };
  w.player = { id: m.hero, kind: 'hero', team: m.team, spec: SPEC[m.spec] || SG.HEROES[0], name: m.name, ranged: !!(SPEC[m.spec] || {}).ranged, r: 24, x: b.x, y: b.y, f: 1, isPlayer: true, human: true, alive: true, hp: 1, maxHp: 1, mp: 0, maxMp: 1, st: blankStatus(), vis: [true, true],
    input: {}, items: [null, null, null, null, null, null], skillLv: [0, 0, 0, 0], cd: [0, 0, 0, 0], icd: [0, 0, 0, 0, 0, 0], lv: 1, exp: 0, gold: 0, atk: 0, armor: 0, asp: 100, ms: 300, anim: 'idle', animSeq: 0, loop: 'idle', brush: -1 };
  w.buy = (u, id) => { send({ t: 'buy', id }); return true; };
  w.sell = (u, slot) => { if (!u.items[slot]) return false; send({ t: 'sell', slot }); return true; };
  w.swapItems = (u, a, b) => { if (a === b || (!u.items[a] && !u.items[b])) return false; [u.items[a], u.items[b]] = [u.items[b], u.items[a]]; send({ t: 'swap', a, b }); return true; }; // 先在畫面換好，伺服器下一次回報會校正
  w.heroes = (team) => w.board.filter((h) => team === undefined || h.team === team);
  let acc = 0;
  const last = { moveTo: undefined, target: undefined, amove: undefined };
  w.net = {
    update(dt, readInput) {
      // 其他單位：緩衝內插（src/net/interp.ts）；還沒有歷史的退回舊的「每幀追一點」
      const k = Math.min(1, dt * 14), rt = w.clock.renderTime(performance.now() / 1000);
      for (const u of w.units) {
        if (u.tx === undefined || (u === w.player && w.pred.on)) continue;
        const p = u.track && u.track.at(rt);
        if (p) { u.x = p[0]; u.y = p[1]; } else { u.x += (u.tx - u.x) * k; u.y += (u.ty - u.y) * k; }
      }
      drainCorrection(w, dt);
      for (const p of w.projs) { p.x += (p.vx || 0) * dt; p.y += (p.vy || 0) * dt; p.t += dt; }
      w.t += dt;
      acc += dt;
      while (acc >= 1 / 30) { acc -= 1 / 30; readInput(); predictStep(w, 1 / 30); sendInput(w, last); }
    },
  };
  world = w;
  SG.Game.begin(w);
}

// ---------- 客戶端預測 ----------
// P.x/P.y 是預測的「物理位置」：每次送出操作前照同樣的操作移動（同一份地圖碰撞與尋路），並記下這個序號之後的位置。
// 畫面上的位置 = 物理位置 + 視覺偏移；校正時物理位置立刻修正，視覺偏移在幾幀內歸零，畫面才不會跳。
const BUSY = /^(attack|s\d|hit|fall|jump)$/;
function predictStep(w, dt) {
  const P = w.pred, u = w.player;
  P.seq++;
  if (!P.on || !P.synced) return;
  const I = u.input, st = u.st;
  let tx = null, ty = null, sx = 0, sy = 0;
  const frozen = !u.alive || st.stun || st.root || st.freeze || st.knockup || st.down || st.fear || st.charm || st.taunt || st.confuse || u.grab || u.defending || BUSY.test(u.anim || '');
  if (!frozen) {
    const m = Math.hypot(I.mx || 0, I.my || 0);
    if (m > 0.1) { sx = I.mx / m; sy = I.my / m; }
    else if (I.moveTo) { tx = I.moveTo[0]; ty = I.moveTo[1]; if (SG.gd(P.x, P.y, tx, ty) < 10) tx = null; }
    else if (I.wpShow && I.wpShow.length) { tx = I.wpShow[0][0]; ty = I.wpShow[0][1]; if (SG.gd(P.x, P.y, tx, ty) < 10) tx = null; } // Shift＋右鍵路徑：預測走向下一個點
    else if (I.target && I.target.alive !== false) { const t = I.target; if (SG.gd(P.x, P.y, t.x, t.y) > (u.range || 90) + (t.r || 20)) { tx = t.x; ty = t.y; } }
    else if (I.amove) { tx = I.amove[0]; ty = I.amove[1]; if (SG.gd(P.x, P.y, tx, ty) < 12) tx = null; }
  }
  // 停滯：伺服器那邊走不動（被擋住、卡住、技能鎖定…），指令沒換之前不再預測，直接貼著伺服器
  const key = (sx || sy) ? 'stick' : tx !== null ? `${Math.round(tx)},${Math.round(ty)}` : '';
  if (key !== P.key) { P.key = key; P.stall = false; }
  if (P.stall) { P.hist.set(P.seq, [P.x, P.y]); return; }
  // 目的地在樹林裡：和伺服器一樣改走到最近的可走點
  if (tx !== null && !M.walkable(tx, ty, M.BODY)) [tx, ty] = M.nearestFree(tx, ty);
  const step = (P.spd || 280) * dt;
  if (sx || sy) { SG.move(P, sx * step, sy * step); if (Math.abs(sx) > 0.15) u.f = sx > 0 ? 1 : -1; }
  else if (tx !== null) {
    // 直線走得到就直走，否則照導航圖找路（目標換了或每秒重找一次）
    let wx = tx, wy = ty;
    if (!SG.clearLine(P.x, P.y, tx, ty)) {
      P.pathT -= dt;
      if (!P.path || !P.goal || Math.hypot(P.goal[0] - tx, P.goal[1] - ty) > 120 || P.pathT <= 0) { P.path = M.path(P.x, P.y, tx, ty); P.goal = [tx, ty]; P.pathT = 1; }
      while (P.path.length > 1 && Math.hypot(P.path[0][0] - P.x, P.path[0][1] - P.y) < 40) P.path.shift();
      if (P.path.length > 1 && SG.clearLine(P.x, P.y, P.path[1][0], P.path[1][1])) P.path.shift();
      wx = P.path[0][0]; wy = P.path[0][1];
    } else P.path = null;
    const gx = wx - P.x, gy = (wy - P.y) / SG.K, d = Math.hypot(gx, gy);
    if (d > 0.5) { const s2 = Math.min(d, step); SG.move(P, (gx / d) * s2, (gy / d) * s2); if (Math.abs(gx) > d * 0.15) u.f = gx > 0 ? 1 : -1; }
  }
  P.hist.set(P.seq, [P.x, P.y]);
  if (P.hist.size > 120) P.hist.delete(P.hist.keys().next().value);
}
// 伺服器回報處理到第 ack 號：拿當時的預測位置和伺服器位置比對；差太多（瞬移、復活、被擊退）直接跳過去
function reconcile(w, u, sx, sy, ack, spd) {
  const P = w.pred;
  P.spd = spd || P.spd; P.srv = [sx, sy];
  if (!P.synced) { P.x = sx; P.y = sy; P.ox = P.oy = 0; P.synced = true; P.hist.clear(); return; }
  const h = ack != null ? P.hist.get(ack) : null;
  for (const k of [...P.hist.keys()]) if (ack != null && k <= ack) P.hist.delete(k);
  if (!h) return;
  // 停滯偵測：伺服器沒在動，而預測在動、或預測和伺服器的差距一直消不掉（例如卡在樹邊，碰撞每幀把預測推回同一點），
  // 連續兩次 → 伺服器那邊走不了，先別預測。剛開始移動時對應序號的預測還和伺服器一致，不會誤判
  const srvMoved = P.lastSrv ? Math.hypot(sx - P.lastSrv[0], sy - P.lastSrv[1]) : 99;
  const predMoved = P.lastH ? Math.hypot(h[0] - P.lastH[0], h[1] - P.lastH[1]) : 0;
  const gap = Math.hypot(sx - h[0], sy - h[1]);
  P.still = srvMoved < 1 && (predMoved > 8 || gap > 6) ? (P.still || 0) + 1 : 0;
  P.lastSrv = [sx, sy]; P.lastH = [h[0], h[1]];
  if (P.still >= 2 && !P.stall) { P.stall = true; P.ox += P.x - sx; P.oy += P.y - sy; P.x = sx; P.y = sy; P.hist.clear(); return; }
  const ex = sx - h[0], ey = sy - h[1];
  if (Math.abs(ex) + Math.abs(ey) < 0.5) return;
  if (Math.hypot(ex, ey) > 220) { P.x = sx; P.y = sy; P.ox = P.oy = 0; P.hist.clear(); P.path = null; return; }
  P.x += ex; P.y += ey; P.ox -= ex; P.oy -= ey; // 物理位置立刻修正；畫面先維持原位，再慢慢跟上
  for (const [k, v] of P.hist) P.hist.set(k, [v[0] + ex, v[1] + ey]);
}
function drainCorrection(w, dt) {
  const P = w.pred;
  if (!P || !P.on || !P.synced) return;
  const k = Math.min(1, dt * 10);
  P.ox -= P.ox * k; P.oy -= P.oy * k;
  if (Math.abs(P.ox) + Math.abs(P.oy) < 0.2) P.ox = P.oy = 0;
  w.player.x = P.x + P.ox; w.player.y = P.y + P.oy;
}

function sendInput(w, last) {
  const I = w.player.input, r = (p) => (p ? [Math.round(p[0]), Math.round(p[1])] : null);
  const msg = { seq: w.pred.seq, mx: +(I.mx || 0).toFixed(2), my: +(I.my || 0).toFixed(2), attack: !!I.attack, defend: !!I.defend, aim: r(I.aim) };
  if (I.engageReq) { msg.eg = 1; I.engageReq = false; } // 進入攻擊狀態（單次）
  if (I.wpClr) { msg.wpClr = 1; I.wpClr = false; } // 路徑點：先清再加（同一則裡順序不會亂）
  if (I.wpAdd) { msg.wpAdd = I.wpAdd.map(r); I.wpAdd = null; }
  if (I.moveTo !== last.moveTo) { msg.moveTo = r(I.moveTo); last.moveTo = I.moveTo; }
  if (I.amove !== last.amove) { msg.amove = r(I.amove); last.amove = I.amove; }
  if (I.target !== last.target) { msg.target = I.target ? I.target.id : null; last.target = I.target; }
  if (I.learn != null) { msg.learn = I.learn; I.learn = null; }
  if (I.skill) { msg.skill = { i: I.skill.i, x: I.skill.x == null ? null : Math.round(I.skill.x), y: I.skill.y == null ? null : Math.round(I.skill.y), tid: I.skill.tid == null ? null : I.skill.tid }; I.skill = null; } // tid：點擊技的目標
  for (const k of ['jump', 'grab', 'punch', 'cancel', 'hard', 'recall', 'stop', 'disengage']) if (I[k]) { msg[k] = true; I[k] = false; }
  if (I.item != null) { msg.item = I.item; I.item = null; }
  if (I.ml) { msg.ml = I.ml; I.ml = null; } // 謀略
  send({ t: 'in', i: msg });
}

function apply(m) {
  const w = world;
  if (lastRoom && (!apply.saved || Date.now() - apply.saved > 5000)) { apply.saved = Date.now(); try { localStorage.setItem('sankuo-session', JSON.stringify({ room: lastRoom, t: Date.now(), live: true })); } catch (e) { /* 忽略 */ } }
  w.t = m.t; w.kills = m.k; w.wind = m.wind; w.supply = m.supply; w.lubu = m.lb ? m.lb.map((v) => (v > 0 ? m.t + v : 0)) : null;
  w.clock.observe(m.t, performance.now() / 1000);
  const seen = new Set();
  for (const o of m.u) {
    let u = w.byId.get(o.i);
    if (!u) {
      const n = o.n;
      if (!n) continue;
      u = o.i === w.myId ? w.player : { input: {}, st: blankStatus(), vis: [true, true], items: [], skillLv: [0, 0, 0, 0], cd: [0, 0, 0, 0], icd: [0, 0, 0, 0, 0, 0], brush: -1, dmgBy: {} };
      Object.assign(u, { id: o.i, kind: n.k, team: n.tm, spec: n.sp ? specOf(n.sp, n.sk) : null, name: n.nm, r: n.r, structure: !!n.st, tier: n.tier, lane: n.ln, ranged: !!n.rg, human: !!n.hu, siege: n.sg || null, x: o.x, y: o.y });
      if (n.ow) { u.owl = true; u.fly = n.ow; } // 貓頭鷹：在空中盤旋
      if (n.bs) { u.beast = n.bs; u.spec = { id: n.bs, name: n.nm, fx: n.bs.startsWith('water') ? '#5ab8ff' : n.bs === 'spirit' ? '#b48cff' : '#ffb24a' }; } // 召喚獸：用專屬造型畫，不要畫成小兵
      w.byId.set(o.i, u);
    }
    seen.add(o.i);
    if (u === w.player && w.pred.on && o.me) reconcile(w, u, o.x, o.y, o.me.ack, o.me.spd);
    else {
      u.tx = o.x; u.ty = o.y;
      if (!u.track) u.track = new Track();
      if (Math.hypot(u.x - o.x, u.y - o.y) > 260) { u.x = o.x; u.y = o.y; u.track.reset(m.t, o.x, o.y); } // 瞬移、復活
      else u.track.push(m.t, o.x, o.y);
    }
    u.f = o.f; u.hp = o.hp; u.maxHp = o.mh; u.anim = o.a; u.animSeq = o.q; u.loop = o.l;
    const fl = o.fl, st = u.st;
    u.alive = !!(fl & 1); u.noPx = !!(fl & 2); u.air = !!(fl & 4); st.invis = fl & 8 ? 1 : 0; u.brush = fl & 16 ? 0 : -1;
    st.stun = fl & 32 ? 1 : 0; st.fear = fl & 64 ? 1 : 0; st.silence = fl & 128 ? 1 : 0; st.root = fl & 256 ? 1 : 0;
    u.seal = !!(fl & 512); u.defending = !!(fl & 1024); u.grab = fl & 2048 ? {} : null;
    st.knockup = fl & 4096 ? 1 : 0; st.down = fl & 8192 ? 1 : 0; st.freeze = fl & 16384 ? 1 : 0; st.taunt = fl & 32768 ? 1 : 0; st.charm = fl & 65536 ? 1 : 0;
    st.confuse = fl & 131072 ? 1 : 0; st.disarm = fl & 262144 ? 1 : 0;
    if (!o.me) { st.slow = fl & 524288 ? 1 : 0; st.slowAmt = st.slow ? 0.3 : 0; }
    if (o.d != null) u.deadT = o.d;
    st.shield = o.sh || 0;
    if (!u.structure) decodeVx(u, o.vx, (id) => SPEC[id]); // 武將專屬的畫面狀態（元素印記小兵也有）
    else u.gone = !u.alive && u.deadT != null && m.t - u.deadT > 3; // 倒下 3 秒的建築不再畫（跟 sim 一樣）
    if (u.kind === 'hero') {
      u.mp = o.mp; u.maxMp = o.mm; u.lv = o.lv; u.kills = o.kda[0]; u.deaths = o.kda[1]; u.assists = o.kda[2];
      u.items = o.it.map((id) => (id ? SG.ITEM[id] : null)); u.iq = o.iq || u.items.map((x) => (x ? 1 : 0)); u.respawn = o.rs || 0;
      if (o.kb) u.deathBy = o.kb;
    }
    if (o.me) {
      const e = o.me;
      Object.assign(u, { gold: e.g, wood: e.wd || 0, pts: e.pt || 0, attr: e.at || 0, manual: true, exp: e.ex, cd: e.cd, skillLv: e.sl, icd: e.icd, atk: e.atk, armor: e.ar, asp: e.as, ms: e.ms, cdr: e.cdr, ml: e.ml || null, mlCd: e.mlc || 0, tp: e.tp ? { t: e.tp } : null, tgOn: e.tg ? Object.assign({}, e.tg.map((v) => !!v)) : null, rc: e.rs ? Object.assign({}, e.rs.map((v, i) => (v === 2 ? { alt: u.spec.skills[i].then, until: Infinity } : v ? { until: Infinity } : null))) : null, mr: e.mr || 0, apen: e.ap || 0, mpen: e.mp2 || 0, matk: e.ma || 0, talN: e.tn || 0, str: e.sa ? e.sa[0] : 0, agi: e.sa ? e.sa[1] : 0, int: e.sa ? e.sa[2] : 0 });
      u.rdy = e.rd || null; // 蓄好了的被動（技能按鈕發光）
      if (e.sn) e.sn.forEach((n, i) => { const s = SG.skillAt(u, i); if (s && s.stack) u[s.stack] = n; }); // 會累積的被動層數（技能按鈕顯示）
      Object.assign(st, e.st);
    }
    u.vis[0] = u.vis[1] = true;
  }
  for (const id of [...w.byId.keys()]) if (!seen.has(id) && id !== w.myId) w.byId.delete(id);
  w.units = [...w.byId.values()];
  // 觀戰：鏡頭跟著選定的武將（1～0 鍵切換）；w.player 只是鏡頭用的替身，不在單位列表裡
  if (w.spectator) {
    const hs = w.units.filter((u) => u.kind === 'hero').sort((a, b) => a.team - b.team || a.id - b.id);
    const f = hs[Math.min(w.follow, hs.length - 1)];
    if (f) Object.assign(w.player, { x: f.x, y: f.y, f: f.f, alive: f.alive, hp: f.hp, maxHp: f.maxHp, name: f.name, lv: f.lv });
  }
  // 戰況表：看不到的敵將也要列出，用最後一次看到的資料
  const known = new Map(w.board.map((h) => [h.id, h]));
  for (const u of w.units) if (u.kind === 'hero') known.set(u.id, u);
  w.board = [...known.values()];
  w.projs = m.pj.map((a) => ({ x: a[0], y: a[1], vx: a[2], vy: a[3], f: a[4], shape: a[5], col: a[6], big: !!a[7], hook: !!a[8], owner: a[8] ? w.byId.get(a[8]) : a[12] ? w.byId.get(a[12]) || null : null,
    homing: a[9] != null, ang: a[9] || 0, tower: !!a[10], t: a[11], visual: true, team: -1 })).filter((p) => !p.hook || p.owner);
  w.zones = m.zn.map((a) => ({ x: a[0], y: a[1], r: a[2], team: a[3], ground: !!a[4], root: !!a[5], dmg: !!a[6], fire: !!a[7], slow: a[8], pal: a[9] || null, look: a[10] || null, owner: a[11] ? w.byId.get(a[11]) || null : null }));
  w.seal = { state: m.seal.s, x: m.seal.x, y: m.seal.y, holder: m.seal.h ? w.byId.get(m.seal.h) || null : null, t: m.seal.t, team: m.seal.tm == null ? -1 : m.seal.tm };
  if (w.seal.state === 'held' && !w.seal.holder) w.seal.state = 'hidden';
  w.vfx.push(...m.fx); w.feed.push(...m.feed); w.msgs.push(...m.msg); w.dmgEvents.push(...m.dmg);
}
